import { apiClient } from './api-client';
import { sectorQuestionsResponseSchema } from './sector-questions.contract';
import { collectAllSectorQuestions } from './sector-questions.pagination';
import type { Question } from '@/types/theme.types';

const PAGE_SIZE = 300;
export { toQuestion } from './sector-questions.pagination';

export async function getSectorQuestionPage(
  sectorId: string,
  language: string | undefined,
  page: number,
  limit = PAGE_SIZE,
  signal?: AbortSignal,
) {
  const response = await apiClient.get(`/themes/sectors/${encodeURIComponent(sectorId)}/questions`, {
    params: { language, page, limit }, signal,
  });
  return sectorQuestionsResponseSchema.parse(response.data);
}

export async function getAllSectorQuestions(
  sectorId: string,
  language: string,
  signal?: AbortSignal,
): Promise<Question[]> {
  return collectAllSectorQuestions((page) =>
    getSectorQuestionPage(sectorId, language, page, PAGE_SIZE, signal));
}
